// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { __assign, __rest } from "tslib";
/* eslint-disable @cloudscape-design/prefer-live-region */ import clsx from "clsx";
import React, { memo } from "react";
import ScreenreaderOnly from "../screenreader-only/index.js";
import styles from "./styles.css.js";
export default /*#__PURE__*/ memo(AriaLiveTag);
function AriaLiveTag(_a) {
    var _b = _a.assertive, assertive = _b === void 0 ? false : _b, _c = _a.visible, visible = _c === void 0 ? false : _c, targetRef = _a.targetRef, sourceRef = _a.sourceRef, children = _a.children, restProps = __rest(_a, [
        "assertive",
        "visible",
        "targetRef",
        "sourceRef",
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, visible && /*#__PURE__*/ React.createElement("span", {
        ref: sourceRef
    }, children), /*#__PURE__*/ React.createElement(ScreenreaderOnly, __assign({}, restProps, {
        className: clsx(styles.root, restProps.className)
    }), !visible && /*#__PURE__*/ React.createElement("span", {
        ref: sourceRef,
        "aria-hidden": "true"
    }, children), /*#__PURE__*/ React.createElement("span", {
        ref: targetRef,
        "aria-atomic": "true",
        "aria-live": assertive ? "assertive" : "polite"
    })));
} //# sourceMappingURL=aria-liva-tag.js.map
